import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GamesService } from '../Services/games.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-games',
  templateUrl: './games.component.html',
  styleUrls: ['./games.component.css']
})
export class GamesComponent implements OnInit {
 games_list:any;
 games_top:any;
 id:string;
 cats=[];
 sources=[];
 cat_games:string='all';
  gamename: string = '';
  catname: string = 'all';
  gamesource: string = 'all';
  constructor( private router:Router ,private games:GamesService , private activeroute:ActivatedRoute) {
  this.id=this.activeroute.snapshot.params['id'];
  console.log(this.id);
    this.getgames();
   }

  ngOnInit() {
   this.getAllCats();
   this.getAllSources();
  }

  /**
   * get all
   *@description get all cats from backend
   */

   getAllCats(){
     this.games.getAllCats().subscribe(next=>{
       this.cats=next['cat_lists'];
       console.log(next['cat_lists']);
     },error=>{console.log(error)});
   }


  getAllSources(){
     this.games.getAllSources().subscribe(next=>{
       this.sources=next['user_lists'];
       console.log(next['user_lists']);
     },error=>{console.log(error)});
   }




  //show function
  show(game_id){
    console.log(game_id)
    this.router.navigate(['/gamepage',game_id,this.id]);
    console.log("you addthis");
  }

  //get the list of games
getgames(){
  this.games.getMygames(this.id).subscribe(
    next=>{
      console.log(next);
      this.games_list=next['games_list']
       this.games_top=next['top']},
    error=>{console.log(error)}
  )
}
//filter game by category
catGame(id){
  if(id=='all'){
 this.cat_games=id;}
 else {
   var data= new FormData();
   data.append('game_cat',id);

   this.games.catGames(data).subscribe(
     next=>{console.log(next),this.games_list= next['game_list']
     this.cat_games=id;},
     error=>{console.log('error')}
   )

 }

 console.log(id);
}

  searchforgames(){
    var data= new FormData();
    data.append('gamename',this.gamename);
    data.append('catname',this.catname);
    data.append('gamesource',this.gamesource);

    this.games.getSearchGames(data).subscribe(
      next=>{
        console.log(next);
          this.games_list= next['game_list'];
        },
      error=>{console.log('error')}
    )
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/games/games.component.ts